import type { RestaurantSnapshot, RestaurantSimulator } from '@modo-vivo/scenario-restaurant';

interface Props {
  sim: RestaurantSimulator | null;
  snapshot: RestaurantSnapshot | null;
  activeTable: number;
  onActiveTableChange: (n: number) => void;
}

export function SimulatorPanel({ sim, snapshot, activeTable, onActiveTableChange }: Props) {
  const pendingOrder = snapshot?.kitchen.find((k) => k.tableNumber === activeTable && k.status !== 'entregado');

  return (
    <section className="panel-section">
      <h2>Simulador de negocio</h2>
      <p className="hint">Eventos ficticios para demostración. No afectan sistemas reales.</p>

      <h3>Mesa activa</h3>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
        {Array.from({ length: 10 }, (_, i) => i + 1).map((n) => (
          <button
            key={n}
            type="button"
            className={`action ${n === activeTable ? 'primary' : ''}`}
            onClick={() => onActiveTableChange(n)}
          >
            {n}
          </button>
        ))}
      </div>

      <div className="btn-grid">
        <button type="button" className="action primary" onClick={() => sim?.demoCustomerArrival()}>
          1. Llegada clientes
        </button>
        <button type="button" className="action" onClick={() => sim?.demoOpenTable(activeTable)}>
          2. Apertura mesa
        </button>
        <button type="button" className="action" onClick={() => sim?.demoAssignWaiter(activeTable)}>
          3. Asignar mozo
        </button>
        <button type="button" className="action" onClick={() => sim?.demoRegisterOrder(activeTable)}>
          4. Registrar pedido
        </button>
        <button type="button" className="action" onClick={() => sim?.demoSendKitchen(activeTable)}>
          5. Enviar cocina
        </button>
        <button
          type="button"
          className="action"
          onClick={() => pendingOrder && sim?.demoPreparing(pendingOrder.orderId)}
          disabled={!pendingOrder}
        >
          6. Preparación
        </button>
        <button
          type="button"
          className="action"
          onClick={() => pendingOrder && sim?.demoReady(pendingOrder.orderId)}
          disabled={!pendingOrder}
        >
          7. Terminado
        </button>
        <button
          type="button"
          className="action"
          onClick={() => pendingOrder && sim?.demoDeliver(pendingOrder.orderId)}
          disabled={!pendingOrder}
        >
          8. Entrega
        </button>
        <button type="button" className="action" onClick={() => sim?.demoBill(activeTable)}>
          9. Solicitar cuenta
        </button>
        <button type="button" className="action" onClick={() => sim?.demoPayment(activeTable)}>
          10. Cobro
        </button>
        <button type="button" className="action" onClick={() => sim?.demoCustomersLeave(activeTable)}>
          11. Retiro clientes
        </button>
        <button type="button" className="action" onClick={() => sim?.demoReleaseTable(activeTable)}>
          12. Liberar mesa
        </button>
        <button type="button" className="action" onClick={() => sim?.demoSupplier()}>
          13. Proveedor
        </button>
        <button type="button" className="action" onClick={() => sim?.demoStockUpdate()}>
          Stock ficticio
        </button>
      </div>

      <h3>Flujo rápido (4 clientes)</h3>
      <button
        type="button"
        className="action primary"
        style={{ width: '100%', marginTop: 4 }}
        onClick={() => {
          for (let i = 0; i < 4; i += 1) {
            setTimeout(() => sim?.demoCustomerArrival(), i * 900);
          }
        }}
      >
        Ingresar 4 clientes a mesas
      </button>
    </section>
  );
}
